export default "__VITE_ASSET__BFi4V$kh__"